<label class="fw-medium mb-1" for="manager">{{label}}</label>
<app-customised-single-select [controls]="{form}" [controlName]="'form'" id="manager"
 [options]="options" [showAvatar]="true"
 placeholder="Select a Manager"
 ></app-customised-single-select>
